<template>
  <div class="page-add">
    <div class="add-title">{{ "申报详情" }}</div>
    <el-form
      class="form"
      size="small"
      label-position="right"
      label-width="120px"
      :model="reportForm"
      ref="reportForm"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="申报名称：" required>
            <span>{{ reportForm.reportYear + reportForm.reportName }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12"
          ><el-form-item label="申报时间：" required>
            <span>{{
              `${reportForm.reportStartTime} 至 ${reportForm.reportEndTime}`
            }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="申报简介：" required>
            <span>{{ reportForm.desc }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item class="scale" label="申报部门：" required>
            <span>{{ reportForm.reportDeptNames }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="scale" label="申报附件：" required>
            <div
              v-if="reportForm.attachmentList &&reportForm.attachmentList.length > 0">
              <div v-for="(item, index) in reportForm.attachmentList" :key="index">
                {{ item.name }}
              <span
                :class="[isImageType(item.name) ? 'file_style' : 'unClick_style']"
                @click.stop="showImgPreview(item)"
                >预览</span
              >
              <span class="file_style" @click="downloadFile(item)">下载</span>
              </div>
            </div>
            <div v-else>暂无</div>
          </el-form-item> 
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="form-handle form-text-center" label-width="0">
            <el-button @click="goBack">返回</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!-- 图片预览 -->
    <el-image-viewer
      v-if="showViewer"
      :on-close="closeViewer"
      :url-list="bigImgList"
    />
  </div>
</template>

<script>
// import { Confirm } from "@/components/Confirm";
import { getClassReportInfo } from "@/api/classReport.js";
// import vue from "../../../main";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";

export default {
  name: "Add",
  components: {ElImageViewer},
  data() {
    return {
      editId: null,
      showViewer: false,
      bigImgList: [],
      reportForm: {
        reportName: "",
        reportYear: "",
        reportStartTime: "",
        reportEndTime: "",
        desc: "",
        reportDeptNames: "",
        attachment: "",
      },
    };
  },
  created() {
    this.editId = this.$route.query.id;
    this.getInfo();
  },
  methods: {
    goBack() {
      this.$router.push('/classReport');
    },
    getInfo() {
      getClassReportInfo({ uuid: this.editId }).then((res) => {
        if (!res || res.code != 0) return;
        let obj = Object.assign({}, res.data);
        if (obj.attachment) {
          obj.attachmentList = JSON.parse(obj.attachment);
        } else {
          obj.attachmentList = [];
        }
        this.reportForm = obj;
      });
    },

    // 查看大图
    showImgPreview(row) {
      if (!this.isImageType(row.name)) {
        return;
      }
      this.showViewer = true;
      this.bigImgList = [row.url];
    },

    //附件下载
    downloadFile(val) {
      let a = document.createElement("a");
      a.href = val.url;
      a.download = val.name;
      a.style.display = "none";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a); 
    },

    // 判断文件类型：图片
    isImageType(name) {
      if (name) {
        const urlIndex = name.lastIndexOf(".");
        let ext = name.substr(urlIndex + 1);
        let flag = ["png", "jpg", "jpeg", "gif", "svg"].indexOf(ext.toLowerCase()) !== -1
        return flag;
      }
      return false;
    },
    closeViewer() {
      this.showViewer = false;
    },
  },
};
</script>

<style lang="scss" scoped>
$textColor: #51627d;
/deep/ .el-input-group__prepend {
  background-color: #909399;
  border: 0px solid #dcdfe6;
  padding: 0 0px;
}
/deep/ .scale .el-input {
  width: 50%;
  color: $textColor;
  font-size: 12px;
}
.form-select {
  width: 100%;
}
/deep/ .el-form-item__content {
  .el-select.yearSelect {
    .el-input--small {
      width: 150px !important;
      margin-right: 10px;
    }
  }
  span {
    color: #000;
    font-size: 14px;
  }

  .file_style {
    color: #3a85ff;
    cursor: pointer;
    margin-left: 16px;
  }
  .unClick_style {
    color: #96a1b2;
    cursor: not-allowed;
    margin-left: 16px;
  }
}
.form-text-center {
  text-align: center !important;
}

</style>
